module.exports = __webpack_public_path__ + "img/bulle-employeur.68c691b.png";